import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext } from '../context';

export const Step20F_ContratoResponsabilidade: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.contractAgreement) newErrors.contractAgreement = 'Campo obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ contractAgreement: data.contractAgreement });
  };

  const handleFieldChange = (value: string) => {
    updateField('contractAgreement', value);
    if (errors.contractAgreement) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.contractAgreement;
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-4">Você concorda em assinar contrato de responsabilidade do consignado (com regras de acerto e devolução) e a nota promissória de garantia das peças consignadas?</p>
      </div>
      <div>
        <ChoiceButtons
          options={[
            { label: 'Sim, concordo e estou ciente das regras', value: 'agree-aware' },
            { label: 'Sim, concordo e gostaria de ler com atenção antes de assinar', value: 'agree-read-first' },
            { label: 'Não concordo', value: 'disagree' },
          ]}
          selected={data.contractAgreement || ''}
          onSelect={handleFieldChange}
        />
        {errors.contractAgreement && (
          <p className="text-red-600 text-sm mt-2">{errors.contractAgreement}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step20F_ContratoResponsabilidade;
